import { Theme } from '@mui/system';

export const getGradientBorderStyles = (theme: Theme) => ({
	'&::before': {
		content: '""',
		position: 'absolute',
		inset: 0,
		borderRadius: '8px',
		padding: '1px',
		background: `linear-gradient(89deg, ${theme.palette.primary.main} 8.48%, ${theme.palette.primary.dark} 54.13%, ${theme.palette.myway?.main} 99.78%)`,
		WebkitMask:
			'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
		WebkitMaskComposite: 'xor',
		maskComposite: 'exclude',
		pointerEvents: 'none',
	},
});
